import { Typography } from '@mui/material';
import { SectionMain } from 'layouts/ScreenLayout/sections/SectionMain';
// import { border } from 'polished'
import React from 'react';
import { useSelector } from 'react-redux';
import MultiLineChart from 'screens/Ecgscreens/MeadianGraph';
import ReadingsBox from 'screens/Ecgscreens/ReadingsBox';

const MedianGraph = () => {
  const MedianGraphData = useSelector((state) => state.ekgReview.medianBeat);
  const datasets = [
    MedianGraphData?.baseline_median_beat || [] ,
    MedianGraphData?.previous_median_beat || [] ,
    MedianGraphData?.recording_median_beat || [] ,
  ];
  return (
    <>
      <SectionMain
        sx={{
          width: '100%',
          margin: '0px',
          marginTop: '52px',
          '& .Section_bodyContainer__1cVer': {
            backgroundColor: 'transparent !important', 
            border: 'none',
            marginBottom: '0px',
            paddingBottom:'0px'
          },
          '& .css-11lq3yg-MuiGrid-root':{
            display:'flow'
          }

        }}
        headerElement={{
          headerText:  <Typography sx={{ fontWeight: 600, fontSize: 16, color: "rgba(0, 0, 0, 0.87)" , fontFamily: "Work Sans" }}>
           Lead I Median Beat
        </Typography>
        }}
        bodyElement={[
          {
            headerElement: <MultiLineChart data={datasets} />,
          },
        ]}
        footerElement={{
          footerLayout: 'none',
          buttonInputProps: <ReadingsBox probabilityValue={Math.round(MedianGraphData?.probability * 100)}/>,
        }}
      />
    </>
  );
};

export default MedianGraph;
